module.exports = __webpack_public_path__ + "static/media/hilux-4wd-hero.8012a8e2.jpg";